import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../../LoadingSlice";
import { toast } from "react-toastify";

interface CloseIssueState {
  CloseIssue: {
    load: boolean;
    data: [];
  };
}

export const CloseIssueSlice = createSlice({
  name: "closeissue",
  initialState: {
    CloseIssue: {
      load: false,
      data: [],
    },
  } as CloseIssueState,
  reducers: {},
});

export default CloseIssueSlice.reducer;

export const closeissue = createAsyncThunk(
  "closeissue/closeissue",
  async (param: {apiParam: { issue_pin: any, comment: any, warehouse_id: any }, navigation: any}, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.post("api/issueClosed", {
        verified_issue_pin: param.apiParam.issue_pin,
        warehouse_id: param.apiParam.warehouse_id,
        comment: param.apiParam.comment
      });
      thunkAPI.dispatch(toggleLoading());

      if(data?.message === "Inventory is not available for this element"){
        toast.warning(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});
      } else {
        toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});
      }


      const handleonConfirm = () => {
        param.navigation("/verified-issue-summary");
      };
      return data.data;
    } catch (error) {
      toast.error("Something went wrong!",{theme: "colored"});
      thunkAPI.dispatch(toggleLoading());
    }
  }
);
